var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF383C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.25 3v8.85c0 .84 0 1.26.163 1.58a1.5 1.5 0 0 0 .656.657c.32.163.74.163 1.579.163h4.204c.839 0 1.258 0 1.579-.163.282-.144.512-.374.656-.656.163-.32.163-.74.163-1.579V3m-9 0h1.5m-1.5 0H.75m3 0h6m-6 0c0-.699 0-1.048.114-1.324a1.5 1.5 0 0 1 .812-.812C4.95.75 5.3.75 6 .75h1.5c.699 0 1.048 0 1.324.114a1.5 1.5 0 0 1 .812.812c.114.276.114.625.114 1.324m0 0h1.5m0 0h1.5"
  })));
};
export default SvgDelete;